import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useApplicantCheck } from "@/hooks/use-applicant-check";
import { Loader2 } from "lucide-react";

interface ApplicantGuardProps {
  children: ReactNode;
}

export const ApplicantGuard = ({ children }: ApplicantGuardProps) => {
  const { isApplicant, isLoading } = useApplicantCheck();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isApplicant) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
